/**
 * @generated SignedSource<<74f23412886a917642ce5f650f64f940>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionIssueTableColumn = "BUILD_STATUS" | "DEPLOYMENT_STATUS" | "DEVELOPMENT_STATUS" | "FEATURE_FLAG_STATUS" | "ISSUE_ASSIGNEE" | "ISSUE_PRIORITY" | "ISSUE_STATUS" | "MORE_ACTION" | "WARNINGS" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type issueCard_softwareReleasesVersionDetailIssueList_jiraVersion$data = {
  readonly canViewDevTools: boolean | null | undefined;
  readonly devOpsSummarisedEntities?: {
    readonly " $fragmentSpreads": FragmentRefs<"featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities">;
  } | null | undefined;
  readonly versionIssueTableHiddenColumns: ReadonlyArray<JiraVersionIssueTableColumn | null | undefined>;
  readonly " $fragmentSpreads": FragmentRefs<"moreButton_softwareReleasesVersionDetailIssueList_jiraVersion" | "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion">;
  readonly " $fragmentType": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion";
};
export type issueCard_softwareReleasesVersionDetailIssueList_jiraVersion$key = {
  readonly " $data"?: issueCard_softwareReleasesVersionDetailIssueList_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueCard_softwareReleasesVersionDetailIssueList_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    }
  ],
  "kind": "Fragment",
  "name": "issueCard_softwareReleasesVersionDetailIssueList_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionIssueWarningController_IssueWarningProvider_jiraVersion"
    },
    {
      "kind": "ScalarField",
      "name": "canViewDevTools"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "versionIssueTableHiddenColumns"
      },
      "action": "THROW",
      "path": "versionIssueTableHiddenColumns"
    },
    {
      "condition": "isDevopsFeatureDisabledInFedRamp",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "DevOpsSummarisedEntities",
          "kind": "LinkedField",
          "name": "devOpsSummarisedEntities",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "featureFlags_softwareReleasesVersionDetailIssueList_devOpsSummarisedEntities"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "522ae3c2b555fac40be79e26c643efd9";

export default node;
